import { render, staticRenderFns } from "./editMessageConfig.vue?vue&type=template&id=626380ac&"
import script from "./editMessageConfig.vue?vue&type=script&lang=js&"
export * from "./editMessageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626380ac')) {
      api.createRecord('626380ac', component.options)
    } else {
      api.reload('626380ac', component.options)
    }
    module.hot.accept("./editMessageConfig.vue?vue&type=template&id=626380ac&", function () {
      api.rerender('626380ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Approval/MessageConfig/components/editMessageConfig.vue"
export default component.exports